export type CoinMarketCapTokenData = {
  chainId: number;
  address: string;
  name: string;
  symbol: string;
  decimals: number;
  logoURI: string;
};

export type CoinMarketCapTokensResponse = {
  name: string;
  logoUri: string;
  keywords: string[];
  timestamp: string;
  tokens: CoinMarketCapTokenData[];
};
